var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topnav-giving-back-container" },
    _vm._l(_vm.localItems, function(item) {
      return _c(
        "a",
        {
          key: item.image,
          staticClass: "giving-back-item",
          attrs: { href: item.link }
        },
        [
          _c("img", {
            staticClass: "giving-back-image",
            attrs: { src: item.image, alt: item.alt }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "image-text" }, [
            _c("p", {
              staticClass: "image-title",
              domProps: { innerHTML: _vm._s(item.text) }
            })
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }